// VerifySentPage.js (예시)
import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import {fetchWithAuth} from "../utils/fetchWithAuth";

export default function VerifySentPage() {
  const email = new URLSearchParams(useLocation().search).get("email");
  const [msg, setMsg] = useState("");

  const resend = async () => {
    setMsg("");
    try {
      const res = await fetchWithAuth("/resend-verification", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });
      const data = await res.json();
      if (res.ok) setMsg("✅ " + (data.message || "인증 메일을 다시 보냈습니다."));
      else setMsg("❌ " + (data.detail || "재발송에 실패했습니다."));
    } catch {
      setMsg("❌ 네트워크 오류가 발생했습니다.");
    }
  };

  return (
      <div className="min-h-screen bg-gray-100 dark:bg-gray-900 text-white">
        <header className="w-full flex flex-col md:flex-row justify-between items-center px-4 py-4 border-b bg-white dark:bg-gray-800">
          <div className="text-center md:text-left mb-4 md:mb-0">
            <h1 className="text-xl font-bold text-blue-600 dark:text-blue-300">J_Universe</h1>
            <nav className="mt-2 text-sm">
              <Link to="/" className="hover:text-blue-400">메인페이지로 이동</Link>
              <span className="mx-2">|</span>
            </nav>
          </div>
        </header>
        <div className="p-6">
          <h1 className="text-xl font-semibold">이메일 인증이 필요해요</h1>
          <p className="mt-2">
            <b>{email}</b> 로 인증 메일을 보냈습니다. 받은 메일함(스팸함 포함)을 확인해
            링크를 클릭해 주세요. (유효기간 60분)
          </p>

          <button onClick={resend} className="mt-4 px-3 py-2 rounded bg-blue-600 text-white">
            인증 메일 다시 보내기
          </button>

          {msg && <div className="mt-3 text-sm">{msg}</div>}
        </div>
      </div>
  );
}
